<ng-container *ngIf="tableMetaData">
    <table *ngIf="recordsExists(); else (noInitDataTemplate || noInitDataTemplateDefault)">
        <thead>
            <tr>
                <ng-template
                    *ngFor="let column of tableMetaData?.columnsConfig; trackBy:trackByColumn"
                    [ngTemplateOutlet]="TH"
                    [ngTemplateOutletContext]="{ column: column }">
                </ng-template>
            </tr>
        </thead>

        <tbody>
            <ng-container *ngFor="let row of tableData; trackBy:trackByRow; let index = index">
                <tr
                    (mouseover)="rowHovered[index]=true"
                    (mouseleave)="rowHovered[index]=false"
                    (click)="handleRowClick($event, row)"
                    [class.interactive]="isRowClickable"
                    [class.grid-active-state]="row.active"
                    [class.row-clickable]="row.isRowClickable"
                    [tooltip]="rowTooltip"
                    container="body"
                >

                    <ng-container *ngFor="let column of tableMetaData?.columnsConfig; trackBy:trackByColumn">
                        <td *ngIf="isColumnVisible(row, column)">
                            <ng-template
                                [ngTemplateOutlet]="(['requestName'].includes(column.columnName)) && row.visitorCount ? collapseControlTemplate
                                    : transcludeTemplate ? transcludeTemplate
                                    : TD"
                                [ngTemplateOutletContext]="{
                                    row: row,
                                    column: column,
                                    index: index
                                }">
                            </ng-template>
                        </td>
                    </ng-container>
                </tr>

                <!-- Expanded row -->
                <ng-container *ngIf="isExpandedRow(row) && detailsData[row.requestId]">
                    <ng-container *ngFor="let detailsItem of detailsData[row.requestId]; let innerIndex = index">
                        <tr class="details-row"
                            [class.interactive]="isRowClickable"
                            (click)="handleRowClick($event, row)"
                            (mouseover)="detailsRowHovered[row.requestId][innerIndex]=true"
                            (mouseleave)="detailsRowHovered[row.requestId][innerIndex]=false">

                            <ng-container *ngFor="let column of tableMetaData?.columnsConfig">
                                <td *ngIf="isColumnVisible(row, column)">
                                    <ng-template
                                        [ngTemplateOutlet]="transcludeDetailsTemplate ? transcludeDetailsTemplate : TD"
                                        [ngTemplateOutletContext]="{
                                            row: detailsItem,
                                            column: column,
                                            index: index,
                                            innerIndex: innerIndex
                                        }">
                                    </ng-template>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-container>
                </ng-container>
            </ng-container>

            <!-- no filtered data template -->
            <tr *ngIf="!tableData.length && recordsExists() && isFilterApplied()">
                <ng-container [ngTemplateOutlet]="noDataTemplate" [ngTemplateOutletContext]="noFilteredDataConfig"></ng-container>
            </tr>

            <!-- no searched data template -->
            <tr *ngIf="!tableData.length && recordsExists() && isSearchApplied() && !isFilterApplied()">
                <ng-container [ngTemplateOutlet]="noDataTemplate" [ngTemplateOutletContext]="noSearchedDataConfig"></ng-container>
            </tr>

            <!--no data template-->
            <tr *ngIf="!tableData.length && recordsExists() && !isFiltersOrSearchApplied()">
                <ng-container [ngTemplateOutlet]="noDataTemplate" [ngTemplateOutletContext]="noDataConfig"></ng-container>
            </tr>
        </tbody>
    </table>
</ng-container>

<ng-template #noDataTemplate let-image="image" let-text="text" let-subtext="subtext">
    <td [colSpan]="visibleColumnsCount" class="no-data-wrapper">
        <div class="no-data">
            <img [src]="image"
                [alt]="text"
                class="no-data__img">
            <div class="no-data__text">{{ text }}</div>
            <div *ngIf="subtext" class="no-data__subtext">{{ subtext }}</div>
        </div>
    </td>
</ng-template>

<!-- PAGING -->
<ui-pagination-new
    *ngIf="tableMetaData?.count && !hidePagination"
    [pagingInfo]="pagination"
    [pageSizesList]="pageSizesList"
    (applyPaging)="onPaginationChange($event)"
    class="paging"
></ui-pagination-new>

<!--THEAD CELL template-->
<ng-template #TH let-column="column">
    <th *ngIf="!column.isHidden" [style.width]="column.isHighlightColumn ? '2%' : column.width || columnWidth" class="{{column.columnName}}">
        <div class="head-block">

            <!-- Checkbox -->
            <label class="d-flex align-items-center checkbox-label" *ngIf="column.hasCheckbox; else thValue">
                <input
                    type="checkbox"
                    (click)="toggleAllChecked.emit()"
                    [checked]="isAllChecked"
                    [indeterminate]="isSomeChecked"
                    [disabled]="isAllDisabled">
                <span></span>
            </label>

            <ng-template #thValue>
                <span *ngIf="!column.isHighlightColumn" appEllipsisTooltip [ngClass]="{ 'applied': isColumnFiltered(column.columnName) || isColumnSorted(column.sortName) }">{{ column.displayName }}</span>
            </ng-template>

            <!--Filter-->
            <i *ngIf="column.hasFilter"
               (click)="showColumnFilters(column.columnName)"
               [ngClass]="{ 'applied': isColumnFiltered(column.columnName) }"
               class="column-state-control icon-table_filter"></i>

            <!--DateRange picker-->
            <span *ngIf="column.hasDateRangeFilter && !clearDaterange">
                <ui-date-range-picker
                    [positionDateRange]="positionDateRange"
                    [start]="gridRequest.columnFilters[column.columnName] ? gridRequest.columnFilters[column.columnName][0] : null"
                    [end]="gridRequest.columnFilters[column.columnName] ? gridRequest.columnFilters[column.columnName][1] : null"
                    [hasSort]="false"
                    [isFiltered]="isColumnFiltered(column.columnName)"
                    [columnName]="column.columnName"
                    [sortOrderName]="column.sortName"
                    [sortOrderCurrent]="sortOrder"
                    (dateRangeChanged)="dateRangeFilterChanged($event)"
                >
                </ui-date-range-picker>
            </span>

            <!--Sorting-->
            <i *ngIf="column.sortName"
                class="column-state-control icon-table_sort_z_a"
                [class.applied]="isColumnSorted(column.sortName)"
                [class.asc]="isAscOrder(column)"
                (click)="toggleColumnSort(column)"></i>

            <!--Filters popup-->
            <ui-grid-filters
                *ngIf="displayColumnFilters === column.columnName"
                [filtersList]="filters[column.columnName]"
                [selectedOptionsList]="gridRequest.columnFilters[column.columnName] || []"
                (applyFilters)="applyColumnFilters($event, column.columnName)"
                class="grid-filters"
            >
            </ui-grid-filters>
        </div>
    </th>
</ng-template>

<!--REGULAR CELL template-->
<ng-template #TD let-column="column" let-row="row">
    <!-- Highlight column - show colored indicator -->
    <div *ngIf="column.isHighlightColumn; else normalCell" 
         [class]="row[column.columnName] ? 'highlighted-cell' : ''">
    </div>
    
    <!-- Normal cell content -->
    <ng-template #normalCell>
        <div
            *ngIf="row[column.columnName]"
            [innerHTML]="column.isUsedInCommonSearch ? (row[column.columnName] | htmltransfrom | highlight: gridRequest.textFilter) : row[column.columnName]">
        </div>
    </ng-template>
</ng-template>

<!--CELL template for collapsible icon-->
<ng-template #collapseControlTemplate let-column="column" let-row="row">
    <div class="expandable-cell-content d-flex align-items-center">
        <i
            class="collapse-icon icon-arrow-expand"
            [ngClass]="{'collapsed': collapsedRows[row.requestId]}"
            (click)="collapse(row)">
        </i>

        <!-- counter -->
        <div *ngIf="row[column.columnName]" class="collapsed-row">{{ row[column.columnName] }}</div>
        <div class="counter">{{ row.visitorCount }}</div>

    </div>
</ng-template>

<!--NO INIT DATA template-->
<ng-template #noInitDataTemplateDefault>
    <div class="no-data">
        <img [src]="noInitDataImgPath"
             [alt]="noInitDataText"
             class="no-data__img">
        <div class="no-data__text">{{ noInitDataText }}</div>
        <div *ngIf="noInitDataSubtext" class="no-data__subtext">{{ noInitDataSubtext }}</div>
    </div>
</ng-template>
